import { BRAND_NAME, BRAND_TAGLINE } from "@/lib/brand";

const LOGO_SRC = "/brand/logo/logo.svg";
const LOGO_DARK_SRC = "/brand/logo/logo-dark.svg";
const ICON_SRC = "/brand/logo/icon.svg";

const LOGO_LOCKUP_CLASS =
  "inline-block h-auto w-full max-w-full shrink-0 object-contain object-left";

/** Lockup из ассетов маркетолога (public/brand/logo). */
export function LogoAssetWordmark({
  compact = false,
  showTagline: _showTagline = true,
  iconOnly = false,
  iconSize,
  wordmarkOnly = false,
}: {
  compact?: boolean;
  showTagline?: boolean;
  iconOnly?: boolean;
  iconSize?: number;
  wordmarkOnly?: boolean;
}) {
  void _showTagline; // в SVG tagline уже врисован — отдельного режима нет
  const markH = iconSize ?? (compact ? 34 : 40);

  if (iconOnly) {
    return (
      // eslint-disable-next-line @next/next/no-img-element -- SVG brand asset
      <img
        src={ICON_SRC}
        alt={BRAND_NAME}
        width={markH}
        height={markH}
        className="inline-block shrink-0"
        style={{ width: markH, height: markH }}
        decoding="async"
      />
    );
  }

  // Ширину задаёт контейнер (брендбук: 190 / 300px в шапке); высота по aspect 5:1.
  const maxHeight = wordmarkOnly ? 28 : compact ? 32 : 40;
  const alt = `${BRAND_NAME} ${BRAND_TAGLINE}`;

  // Два SVG + CSS по data-theme / data-landing-resolved — без смены src на клиенте (hydration-safe).
  return (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element -- SVG brand asset */}
      <img
        src={LOGO_SRC}
        alt={alt}
        className={`logo-asset-lockup logo-asset-lockup--light ${LOGO_LOCKUP_CLASS}`}
        style={{ maxHeight }}
        decoding="async"
      />
      {/* eslint-disable-next-line @next/next/no-img-element -- SVG brand asset */}
      <img
        src={LOGO_DARK_SRC}
        alt={alt}
        className={`logo-asset-lockup logo-asset-lockup--dark ${LOGO_LOCKUP_CLASS}`}
        style={{ maxHeight }}
        decoding="async"
      />
    </>
  );
}
